import * as React from "react";
import { SVGProps } from "react";

const SmoothLovePotion = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 134 159" {...props}>
    <path
      fill="#0b4431"
      d="M65.6 159.5h-.2c-33.4-.1-49.4-16.1-57-29.4-7-12.4-9.7-26-7.8-40.4 1.5-12 6.3-24.6 13.9-36.2 4.8-7.4 11.1-14.9 17.8-21 4.9-4.5 8.9-7.4 12.1-8.7-1-4.1-1.6-10.6-1.8-12.8v-.4c-.1-5.1 5.6-7.4 7.5-8.2C53.7.9 58 .1 62.1 0s8.2.2 11.6 1c2.1.5 8.4 1.9 8.5 7.3l.3 9.2c0 1.7-.1 3.2-.3 4.6 17.9 6.3 33.1 25.2 39.3 35.4 2.5 4.1 8.6 15.2 11.3 29.1 3.2 16.7.5 31.6-8.1 44.5-17.7 26.3-49.4 28.4-59.1 28.4zM47.8 34.1c-4 2.2-15.6 11.9-24.2 25.3-8.5 13.1-20.6 39.1-5.7 65.4 8.8 15.6 25.3 23.9 47.6 24h.2c8.3 0 35.4-1.8 49.9-23.6 17.1-25.6.2-56.1-3.4-61.9-3.1-5.1-9.4-13.4-17.2-20.4l-32.7-5-24.8 4.9 13.1-7.4c-.5-.2-1-.4-1.5-.7-.5-.2-1-.4-1.3-.6zm29.9-.2L90 38.7c-3.3-2.4-6.7-4.5-10.3-5.9-.5.3-1 .6-1.6.9-.1.1-.2.2-.4.2zm-29-.2zm4.8-21c.5 4.1 1.1 8.3 1.5 9.5.8 2.2 2.1 3.6 4.1 4.4l4 1.6 3.4-1.9c1.8-1 3-2.5 3.1-2.6l.4-.6.2-.1c.3-.4 1.3-2 1.2-5.1v-6.3c-1.9-.5-5.2-.9-9.1-.8-3.7.1-7 1.1-8.8 1.9z"
    />
    <path
      fill="#77baa1"
      d="M120 128.1c-16.4 24.7-46.8 26-54.6 26-9.8 0-37.9-1.2-52.3-26.7C-.7 103 5.8 76.7 19 56.4c10.3-15.9 25.1-27.9 28.9-28.1.7 0 1.8.7 3.5 1.5 2.4 1.1 6.1 2.5 11.9 2 6.7-.6 10.3-1.8 12.4-2.9 2.4-1.2 3-2.2 4-1.8 17.2 5.8 31.8 24.7 37.1 33.3 5.7 9.4 21.3 40.6 3.2 67.7z"
    />
    <path
      fill="#f3acbb"
      d="M22.1 74.3s-7.5 18.3-5.9 32c1.5 13.2 10.4 32.8 32.2 37.6s35.9-.8 48-6.2c12-5.4 20.3-16.7 21.5-27.4s1.3-26.3-4.7-39"
    />
    <path
      fill="#89b772"
      d="M75.3 40.7c-.7 2.5-12.1 4.9-17.3 3.5-5.1-1.4-5.5-4.7-6.7-14.4 2.4 1.1 6.1 2.5 11.9 2 6.7-.6 10.3-1.8 12.4-2.9.2 2.5.4 9.4-.3 11.8z"
    />
    <path
      fill="#f08fa2"
      d="M48.2 132.5c-.6-1.4-.7-2.9-.5-4.4.7-5.4 4.5-19.7 24.2-30.5 24.7-13.6 37.7-2.1 37.7-2.1s7.8 6.9 1.9 23.3c-5.9 16.3-34.8 22.3-34.8 22.3s-23 5.3-28.5-8.6zm-23.8-29.9c-1.6 0-1.7-6.3.3-9.1 3.2-4.5 8.7-.3 8.7-.3s-4.8 9.4-9 9.4z"
    />
    <path
      fill="#f8d0d9"
      d="M113.2 71.3c0-2.4-20.4-4.3-45.6-4.3S22 71.9 22 74.3s20.4 6.6 45.6 6.6 45.6-7.2 45.6-9.6z"
    />
    <path
      fill="#dd8843"
      d="M47.9 10.5S49.6 21 50.3 24c.6 2.5 4.5 7.9 11.7 8.7 7.7.8 12.1-5.9 12.1-5.9s3.1-2.9 2.9-9.1-.3-9.2-.3-9.2-16.2 1.5-28.8 2z"
    />
    <path
      fill="#ebb646"
      d="M76.7 8.5c0-1.5-6.7-3.3-14.5-3.1-7.9.2-14.4 3.6-14.3 5.1 0 1.5 6.7 3.8 14.5 3.6 7.9-.2 14.3-4.1 14.3-5.6z"
    />
    <path
      fill="#fff"
      d="M25.8 77.2c-.8-.2-1.4-.7-1.9-1.4-1.4-2.2-3.4-8 4.6-19.1 10.4-14.6 16-9.7 16-9.7s6.9 3.5-.6 15.8c-.1.1-.1.2-.2.3-.7 1.7-8.1 16.8-17.9 14.1zm74.2 58.9c-1.7-.3-2.8-1.8-2.5-3.5.4-2.1 1.6-5.3 5.1-8.4 5.4-4.8 9.3-.5 10.2.7.2.3.3.6.4.9.2 1 .1 3-2.6 6-3.1 3.4-6.9 5-10.6 4.3z"
    />
    <path
      fill="#a5d4c1"
      d="M125 91.8c1 2.6-6.4-7.1-7.4-7.2-1.5-.2-9.1 18.2-11 18.7-2.4.6-21.9-13.6-26.1-13.2-7.5.5-22.9 23.1-24.9 23.5-2.4.4-19.6-20.2-25.8-21-2.1-.3-16.6 17.3-17.8 16-.6-.6-2-14.6-1.8-18.5.2-2.5 1.9 9.8 2.6 9.8 1.2.1 14.5-13.2 17.3-13 2.5.2 22.2 17.7 24.1 17.3 1.9-.4 21-19.2 25.1-19.8 3.2-.4 20.2 11.9 24.8 11.1 2.8-.4 11.4-15.6 12.9-16 1.3-.1 6.9 9.5 8 12.3z"
    />
  </svg>
);

export default SmoothLovePotion;
